function Footer() {
  return (
    <footer>
      <div className="container">
        <p>&copy; 2025 SecondHandArmored.com - Professional armored vehicle sourcing and export services.</p>
        <p>Medellín, Colombia | Email: info@secondhandarmored.com</p>
        <div className="footer-docs">
          <a href="/docs/2026-politica-tratamiento-datos-personales.pdf" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          <span className="footer-docs-sep">|</span>
          <a href="/docs/2026-terminos-y-condiciones-exportacion.pdf" target="_blank" rel="noopener noreferrer">
            Terms & Conditions
          </a>
        </div>
        <div className="footer-brand">
          <a href="https://lapuerta.com.co" target="_blank" rel="noopener noreferrer" className="footer-logo-link">
            <img src="/images/lapuerta-logo-white.png" alt="La Puerta Colombia" className="footer-logo" />
          </a>
          <p className="footer-brand-text">secondhandarmored.com, a La Puerta Colombia brand.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
